var map = {
	"../mainpage/allcontract/allcontract.module": [
		"./src/mainpage/allcontract/allcontract.module.ts",
		"allcontract.module",
		"common"
	],
	"../mainpage/connect/connect.module": [
		"./src/mainpage/connect/connect.module.ts",
		"connect.module",
		"common"
	],
	"../mainpage/firmes/firmes.module": [
		"./src/mainpage/firmes/firmes.module.ts",
		"firmes.module",
		"common"
	],
	"../mainpage/message/message.module": [
		"./src/mainpage/message/message.module.ts",
		"message.module",
		"common"
	],
	"../mainpage/purchase/purchase.module": [
		"./src/mainpage/purchase/purchase.module.ts",
		"purchase.module",
		"common"
	],
	"../mainpage/statistic/statistic.module": [
		"./src/mainpage/statistic/statistic.module.ts",
		"statistic.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main